import { Facet } from "@/components/Search/SearchResults/StateComponents/Facets/Facet/@types/facet.types";
import { FacetType } from "@/components/Search/SearchResults/StateComponents/Facets/Facet/@types/facetType.types";
import {
    FACET_DELIMITER,
    FACET_VALUE_STORE_STOCK_IDENTIFIER
} from "@/components/Search/SearchResults/StateComponents/Facets/Facet/facet.configuration";

export const isShowProductsFacet = (
    facet: Facet<FacetType>
): facet is Facet<FacetType.SHOW_PRODUCTS> => {
    return facet.type === FacetType.SHOW_PRODUCTS;
};

export const isStoreStockFacetValue = (value: string) => {
    return value.startsWith(FACET_VALUE_STORE_STOCK_IDENTIFIER);
};

export const createStoreStockFacetValue = (storeId?: string) => {
    return `${FACET_VALUE_STORE_STOCK_IDENTIFIER}${FACET_DELIMITER}${storeId}`;
};
